import React from 'react';
import { ShieldCheck, RefreshCw, AlertTriangle, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const Refund = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-obsidian text-cream-100 p-6 pt-20">
            <div className="max-w-3xl mx-auto space-y-8">
                <button
                    onClick={() => navigate('/')}
                    className="flex items-center gap-2 text-cream-200/60 hover:text-cream-50 transition-colors"
                >
                    <ArrowLeft size={20} />
                    Back to Home
                </button>

                <header className="space-y-4">
                    <div className="w-12 h-12 rounded-xl bg-danger/20 flex items-center justify-center">
                        <ShieldCheck className="w-6 h-6 text-danger" />
                    </div>
                    <h1 className="text-4xl font-display font-bold text-cream-50">Refund & Escrow Policy</h1>
                    <p className="text-cream-200/60 text-lg">Protecting both Buyers and Sellers</p>
                </header>

                <div className="space-y-8 text-cream-200/80 leading-relaxed">
                    <section className="space-y-4">
                        <div className="bg-copper-500/10 border border-copper-500/20 rounded-2xl p-6">
                            <h2 className="text-xl font-display font-semibold text-copper-400 mb-3 flex items-center gap-2">
                                <ShieldCheck className="w-5 h-5" />
                                The CardBoss Guarantee
                            </h2>
                            <p>
                                Every transaction on CardBoss is protected by our Escrow system. We hold the buyer's payment secure until the item is delivered and verified.
                            </p>
                        </div>
                    </section>

                    <section className="space-y-4">
                        <h2 className="text-2xl font-display font-semibold text-cream-50">1. Escrow Process</h2>
                        <ol className="list-decimal pl-6 space-y-4">
                            <li>
                                <strong>Payment Held:</strong> When you buy a card, your payment is held securely in escrow. The seller does not receive the funds yet.
                            </li>
                            <li>
                                <strong>Shipping:</strong> The seller must ship the item and provide a valid tracking number within 3 business days.
                            </li>
                            <li>
                                <strong>Delivery & Verification:</strong> Once the item is marked as delivered, you have 48 hours to inspect it.
                            </li>
                            <li>
                                <strong>Release:</strong> If you verify the item (or after 48 hours of no disputes), the funds are released to the seller.
                            </li>
                        </ol>
                    </section>

                    <section className="space-y-4">
                        <h2 className="text-2xl font-display font-semibold text-cream-50">2. Refund Eligibility</h2>
                        <p>
                            You are eligible for a full refund if:
                        </p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>The item never arrives (lost in transit).</li>
                            <li>The item is significantly different from the description (e.g., wrong card, different grade).</li>
                            <li>The item is proven to be counterfeit.</li>
                        </ul>
                        <p className="mt-4 text-sm text-cream-200/50">
                            Note: "Buyer's remorse" (changing your mind) is not a valid reason for a refund.
                        </p>
                    </section>

                    <section className="space-y-4">
                        <h2 className="text-2xl font-display font-semibold text-cream-50">3. Dispute Resolution</h2>
                        <p>
                            If there is an issue, you must open a dispute within 48 hours of delivery.
                            Our team will review the evidence (photos, tracking info) and make a final binding decision.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};
